import { useEffect } from "react";

const ADMIN_TITLE_SUFFIX = "Djayma Admin";

/**
 * Sets `document.title` for an admin page on mount and restores the previous
 * title on unmount.  Every admin page should call this hook with its own page
 * name so the browser tab/history entry is meaningful.
 *
 * @example useAdminPageTitle("Commandes");
 *          // → document.title = "Commandes — Djayma Admin"
 */
export function useAdminPageTitle(pageTitle: string): void {
  useEffect(() => {
    const previousTitle = document.title;
    document.title = `${pageTitle} \u2014 ${ADMIN_TITLE_SUFFIX}`;

    return () => {
      document.title = previousTitle;
    };
  }, [pageTitle]);
}
